import { createFileRoute } from '@tanstack/react-router';
import { LedgerAccountsPage } from './LedgerAccountsPage';
import { z } from 'zod';

const searchSchema = z.object({
  name: z.string().optional(),
  benefitId: z.string().optional(),
  accountId: z.string().optional(),
  userId: z.string().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().positive().int().optional().default(25),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/ledger/accounts/')({
  component: LedgerAccountsPage,
  validateSearch: searchSchema,
});
